require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-motion-graphics-designer.json") })
        }
      }, "path---authors-motion-graphics-designer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-motion-graphics-designer!./.cache/json/authors-motion-graphics-designer.json
// module id = 1318
// module chunks = 231608221292675